export enum TableSizes {
  xxl = 1650,
  xl = 1400,
  lg = 1140,
  md = 960,
  sm = 720,
  xs = 540,
}